import { useEffect, useState } from 'react';
import en from 'date-fns/locale/en-US/index';
import useContentfulLocale from '../useContentfulLocale';

const contentfulToDateFnsMapping = {
  'zh-Hans': 'zh-CN',
  'zh-Hant': 'zh-CN',
};

const useDateLocale = () => {
  const [locale, setLocale] = useState(en);
  const ctfLocaleFilter = useContentfulLocale();

  useEffect(() => {
    const dateFnsLocale =
      contentfulToDateFnsMapping[ctfLocaleFilter.locale] ||
      ctfLocaleFilter.locale;
    if (dateFnsLocale && dateFnsLocale !== 'en-US') {
      const importLocaleFile = async () => {
        const localeToSet = await import(
          `date-fns/locale/${dateFnsLocale}/index`
        );
        setLocale(localeToSet.default);
      };

      importLocaleFile();
    }
  }, [ctfLocaleFilter]);

  return locale;
};

export default useDateLocale;
